import {cloneDeep, difference, forEach, isEmpty, keys} from 'lodash'

export const showArrCustomColumns = (columnsInit, columnsShow) => {
  const columnA = cloneDeep(columnsInit).reduce(
    (columnA, item: any) => ({...columnA, [item.id]: item}),
    {}
  )
  let columnB = cloneDeep(columnsShow).reduce(
    (columnB, item: any) => ({...columnB, [item.id]: item}),
    {}
  )

  const newColumns = difference(keys(columnA), keys(columnB))
  if (!isEmpty(newColumns)) {
    forEach(newColumns, (key) => {
      let index = keys(columnA).indexOf(key)
      let value = {
        id: key,
        header: columnA[key].Header,
        show: true,
      }
      let entries = Object.entries(columnB)
      entries.splice(index, 0, [key, value])
      columnB = Object.fromEntries(entries)
    })
  }

  return Object.keys(columnB).map((key) => ({
    ...columnA[key],
    ...columnB[key],
  }))
}

/**
 * Returns the correct form of a word (singular or plural) based on the count.
 * @param count - The number to check.
 * @param singularWord - The word in singular form.
 * @param pluralWord - The word in plural form.
 * @returns The singular or plural form of the word based on the count.
 */
export const textByCount = (count: number, singularWord: string, pluralWord: string): string => {
  return count > 1 ? pluralWord : singularWord
}

/**
 * Format localized AM/PM strings (Chinese/Japanese) to English AM/PM.
 *
 * @param dateTime - The datetime string that may contain localized AM/PM (e.g. "上午", "下午", "午前", "午後", "晚上").
 * @returns The datetime string with AM/PM normalized to English.
 *
 * @example
 * formatAMPM("2025/08/22 11:09:00 上午 +07:00")
 * // "2025/08/22 11:09:00 AM +07:00"
 *
 * formatAMPM("2025/08/22 11:09:00 午後 +07:00")
 * // "2025/08/22 11:09:00 PM +07:00"
 */
export const formatAMPM = (dateTime: string) => {
  return dateTime.replace(/上午|午前/g, 'AM').replace(/下午|晚上|午後/g, 'PM')
}
